export default __webpack_public_path__ + "static/media/yunying.f910c2e9.png";